<template>
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M22.133 6.83h3.273l-7.148 8.192 8.409 11.148h-6.583l-5.16-6.76-5.896 6.76H5.751l7.644-8.763L5.334 6.83h6.749l4.659 6.179zm-1.15 17.378h1.813L11.096 8.69H9.149z"/></svg>
</template>